import React from "react";

const ClosingSection = () => {
  return (
    <section className="py-16 md:py-24 bg-light-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
        {/* Texte à gauche */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <h2 className="text-title font-bold text-dark-1 mb-6 leading-snug">
            Rejoignez le cercle des makers de niveau international avec{" "}
            <span className="text-primary">GoNextMaker Tutorat</span>.
          </h2>
          <p className="text-gray-600 mb-8 text-subtitle">
            Faites le premier pas vers votre avenir et bénéficiez d’un
            accompagnement personnalisé par nos tuteurs experts.
          </p>
          {/* Bouton CTA */}
          <a
            href="https://app.gonextmaker.com/auth/signup"
            className="inline-block px-6 py-3 border-2 border-red-4 text-red-4 text-button
            rounded-full hover:bg-red-4 hover:text-white transition"
          >
            Réserver un appel découverte avec un tuteur
          </a>
        </div>

        {/* Image à droite */}
        <div className="lg:w-1/2 flex justify-center">
          <img
            src="/premium_photo-1661633003570-05d8608fc1bc.jpeg"
            alt="Jeune maker présentant son projet validé"
            className="rounded-3xl max-w-md w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default ClosingSection;
